// eslint-disable-next-line
import { UserLayout, BasicLayout, BlankLayout } from '@/layouts';
// import { bxAnaalyse } from '@/core/icons';

const RouteView = {
  name: 'RouteView',
  render: (h) => h('router-view'),
};

// 角色定义:
// admin - 管理员：所有路由可见
// content_manager - 内容管理员：只能看到内容管理菜单
// blogger - 博客写手：只能看到素材管理和文章列表

export const asyncRouterMap = [
  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    meta: { title: 'menu.home' },
    children: [
      // 管理员仪表盘 - 管理员登录后的默认页
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/index'),
        meta: { title: '仪表盘', icon: 'dashboard', permission: ['dashboard'], roles: ['admin'] },
      },
      {
        path: '/user',
        redirect: '/user/list',
        component: RouteView,
        meta: { title: '用户管理', icon: 'user', permission: ['form'], roles: ['admin'] },
        children: [
          {
            path: '/user/list',
            name: 'user.list',
            component: () => import('@/views/account/index'),
            meta: { title: '列表', keepAlive: true, permission: ['form'], roles: ['admin'] },
          },
          {
            path: '/user/license',
            name: 'user.license',
            component: () => import('@/views/license/index'),
            meta: { title: '密钥', keepAlive: true, permission: ['form'], roles: ['admin'] },
          },
          {
            path: '/user/orders',
            name: 'user.orders',
            component: () => import('@/views/orders/index'),
            meta: { title: '订单', keepAlive: true, permission: ['form'], roles: ['admin'] },
          },
          {
            path: '/user/export-log',
            name: 'user.exportLog',
            component: () => import('@/views/exportLog/index'),
            meta: { title: '导出日志', keepAlive: true, permission: ['form'], roles: ['admin'] },
          },
          {
            path: '/user/editor-error-log',
            name: 'user.editorErrorLog',
            component: () => import('@/views/editorErrorLog/index'),
            meta: { title: '错误日志', keepAlive: true, permission: ['form'], roles: ['admin'] },
          },
          {
            path: '/user/legacy-data',
            name: 'user.legacyData',
            component: () => import('@/views/legacyData/index'),
            meta: { title: '旧数据上报', keepAlive: true, permission: ['form'], roles: ['admin'] },
          },
        ],
      },
      {
        path: '/content',
        redirect: '/content/material',
        component: RouteView,
        meta: { title: '内容管理', icon: 'form', permission: ['form'], roles: ['admin', 'content_manager', 'blogger'] },
        children: [
          {
            path: '/content/material',
            name: 'content.material',
            component: () => import('@/views/material/index'),
            meta: { title: '素材管理', keepAlive: true, permission: ['form'], roles: ['admin', 'content_manager', 'blogger'] },
          },
          {
            path: '/content/tool',
            name: 'content.tool',
            component: () => import('@/views/tool/index'),
            meta: { title: '工具列表', keepAlive: true, permission: ['form'], roles: ['admin', 'content_manager'] },
          },
          {
            path: '/content/tool/create',
            name: 'content.tool.create',
            hidden: true,
            component: () => import('@/views/tool/Form'),
            meta: { title: '工具新增', keepAlive: true, permission: ['form'], roles: ['admin', 'content_manager'] },
          },
          {
            path: '/content/tool/edit/:id',
            name: 'content.tool.edit',
            hidden: true,
            component: () => import('@/views/tool/Form'),
            meta: { title: '工具编辑', keepAlive: true, permission: ['form'], roles: ['admin', 'content_manager'] },
          },
          {
            path: '/content/category',
            name: 'content.category',
            component: () => import('@/views/category/index'),
            meta: { title: '文章分类', keepAlive: true, permission: ['form'], roles: ['admin', 'content_manager'] },
          },
          {
            path: '/content/tag',
            name: 'content.tag',
            component: () => import('@/views/tag/index'),
            meta: { title: '文章标签', keepAlive: true, permission: ['form'], roles: ['admin', 'content_manager'] },
          },
          {
            path: '/content/list',
            name: 'content.list',
            component: () => import('@/views/blog/index'),
            meta: { title: '文章列表', keepAlive: true, permission: ['form'], roles: ['admin', 'content_manager', 'blogger'] },
          },
          {
            path: '/content/create',
            name: 'content.create',
            hidden: true,
            component: () => import('@/views/blog/Form'),
            meta: { title: '文章新增', keepAlive: true, permission: ['form'], roles: ['admin', 'content_manager', 'blogger'] },
          },
          {
            path: '/content/edit/:id',
            name: 'content.edit',
            hidden: true,
            component: () => import('@/views/blog/Form'),
            meta: { title: '文章编辑', keepAlive: true, permission: ['form'], roles: ['admin', 'content_manager', 'blogger'] },
          },
        ],
      },
    ],
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true,
  },
];

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login'),
      },
      {
        path: 'register',
        name: 'register',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Register'),
      },
      {
        path: 'register-result',
        name: 'registerResult',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/RegisterResult'),
      },
      {
        path: 'recover',
        name: 'recover',
        component: undefined,
      },
    ],
  },

  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404'),
  },
];
